<template>
  <div class="empty-table">
    <img src="@/assets/images/exclamation.svg" class="me-2"/>
    <div class="empty-table-text">هنوز فاکتوری ثبت نشده است</div>
  </div>
</template>

<script>
export default {
  name: 'empty-table',
}
</script>

<style>
.empty-table{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -57px;
}
.empty-table-text {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0px;
}
</style>